import { Filter } from '@cubejs-client/core';

import { SpendType } from '~/common/types/cubes/SpendType';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { CUBE, NegotiationSpendWidget } from './NegotiationSpendWidget';

interface SupplierNegotiationSpendWidgetProps {
  spendType: SpendType;
}
export const SupplierNegotiationSpendWidget = ({ spendType }: SupplierNegotiationSpendWidgetProps) => {
  const { entityId } = useModuleContext();

  const filters: Filter[] = [
    {
      member: `${CUBE}.supplier_id`,
      operator: 'equals',
      values: [entityId],
    },
  ];

  return <NegotiationSpendWidget filters={filters} spendType={spendType} />;
};
